import api from './api';
import { Role } from '../types/types';

export const roleService = {
    // Get all roles
    getAllRoles: async (): Promise<Role[]> => {
        const response = await api.get<Role[]>('/roles');
        return response.data;
    },

    // Get role by ID
    getRoleById: async (id: number): Promise<Role> => {
        const response = await api.get<Role>(`/roles/${id}`);
        return response.data;
    },

    // Update role (permissions)
    updateRole: async (id: number, role: Role): Promise<void> => {
        await api.put(`/roles/${id}`, role);
    },
};
